import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';

@JsonObject('ResponcePage')
export class ResponcePage extends AbstractModel {

	@JsonProperty(Number, 'size')
	size: number;

	@JsonProperty(Number, 'number')
	number: number;

	@JsonProperty(Number, 'numberOfElements')
	numberOfElements: number;

	@JsonProperty(Number, 'totalElements')
	totalElements: number;

	@JsonProperty(Number, 'totalPages')
	totalPages: number;

}